import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Typography, FormControl, Select, OutlinedInput, MenuItem, Button} from '@mui/material'

import LanguageContext from "../../../contexts/LanguageContext"
import { useTexte } from "../../../contexts/FormeAdresseContext"
import UserContext from "../../../contexts/UserContext"

import { TopBar, CenterContainer } from "./FormatsHelpers"


const IcebreakerQuestions = ({ actFormation }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)
  /* Tutoiement / vouvoiement selon la cible du module (07/10/2026,
     contexts/FormeAdresseContext.js). */
  const t = useTexte()

  const { currentUser, setActFormation, saveUserFormation } = useContext(UserContext)

  const [canValid, setCanValid] = useState(false)

  const [secteurRep, setSecteurRep] = useState("")
  const [anneesRep, setAnneesRep] = useState("")
  const [diplomeRep, setDiplomeRep] = useState("")

  useEffect(() => {
    let value = true
    if (currentUser?.icebreakerQuestions?.secteurs === true && secteurRep === "") {
      value = false
    }
    if (currentUser?.icebreakerQuestions?.annees === true && anneesRep === "") {
      value = false
    }
    if (currentUser?.icebreakerQuestions?.diplome === true && diplomeRep === "") {
      value = false
    }

    setCanValid(value)
  }, [currentUser, secteurRep, anneesRep, diplomeRep])


  return (
    <Box sx={{
      display:"flex",
      flexDirection:"column",
      height:"100vh",
      overflow:"hidden",
      /* ⛔ Pas de gap racine : la planche colle le contenu au bandeau. */
    }}>
      <TopBar
        actFormation={actFormation}
        setViewPlanCours={null}
      />
      <CenterContainer
        actFormation={actFormation}
      >
        <Box sx={{width:"100%", maxWidth:"600px"}}>
          <Box sx={{ mb: 2, textAlign:"center" }}>
            <Typography
              color="text.blackTitle"
              variant="h2"
            >
              {t(languageValues?.onBoarding?.title)}
            </Typography>
          </Box>
          <Box sx={{display:"flex", flexDirection:"column", columnGap:"20px"}}>
            {currentUser?.icebreakerQuestions?.secteurs === true &&
              <FormControl
                fullWidth
                margin="normal"
                variant="outlined"
                sx={{
                  "& .MuiInputLabel-root" : {
                    color:"black !important"
                  }
                }}
              >
                <Select
                  displayEmpty
                  input={<OutlinedInput />}
                  value={secteurRep}
                  renderValue={(selected, value) => {
                    if (selected === "") {
                      return <font style={{color:'rgba(0,0,0,0.65)',}}>{currentUser?.icebreakerQuestions?.secteursQ}</font>;
                    }

                    return selected
                  }}
                  onChange={(e) => {
                    setSecteurRep(e?.target?.value)
                  }}
                  placeholder="..."
                >
                  <MenuItem disabled value="">
                    <em>{currentUser?.icebreakerQuestions?.secteursQ}</em>
                  </MenuItem>
                  {currentUser?.icebreakerQuestions?.secteursReps?.map((option, key) => {
                    return (
                      <MenuItem value={option} key={key}>
                        {option}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            }
            {currentUser?.icebreakerQuestions?.annees === true &&
              <FormControl
                fullWidth
                margin="normal"
                variant="outlined"
                sx={{
                  "& .MuiInputLabel-root" : {
                    color:"black !important"
                  }
                }}
              >
                <Select
                  displayEmpty
                  input={<OutlinedInput />}
                  value={anneesRep}
                  renderValue={(selected, value) => {
                    if (selected === "") {
                      return <font style={{color:'rgba(0,0,0,0.65)',}}>{currentUser?.icebreakerQuestions?.anneesQ}</font>;
                    }

                    return selected
                  }}
                  onChange={(e) => {
                    setAnneesRep(e?.target?.value)
                  }}
                  placeholder="..."
                >
                  <MenuItem disabled value="">
                    <em>{currentUser?.icebreakerQuestions?.anneesQ}</em>
                  </MenuItem>
                  {currentUser?.icebreakerQuestions?.anneesReps?.map((option, key) => {
                    return (
                      <MenuItem value={option} key={key}>
                        {option}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            }
            {currentUser?.icebreakerQuestions?.diplome === true &&
              <FormControl
                fullWidth
                margin="normal"
                variant="outlined"
                sx={{
                  "& .MuiInputLabel-root" : {
                    color:"black !important"
                  }
                }}
              >
                <Select
                  displayEmpty
                  input={<OutlinedInput />}
                  value={diplomeRep}
                  renderValue={(selected, value) => {
                    if (selected === "") {
                      return <font style={{color:'rgba(0,0,0,0.65)',}}>{currentUser?.icebreakerQuestions?.diplomeQ}</font>;
                    }

                    return selected
                  }}
                  onChange={(e) => {
                    setDiplomeRep(e?.target?.value)
                  }}
                  placeholder="..."
                >
                  <MenuItem disabled value="">
                    <em>{currentUser?.icebreakerQuestions?.diplomeQ}</em>
                  </MenuItem>
                  {currentUser?.icebreakerQuestions?.diplomeReps?.map((option, key) => {
                    return (
                      <MenuItem value={option} key={key}>
                        {option}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            }


          </Box>

          <Box sx={{ py: 2 }}>
            <Button
              color="primary"
              disabled={!canValid}
              fullWidth
              size="large"
              variant="contained"
              onClick={() => {
                let newFormation = JSON.parse(JSON.stringify(actFormation))
                let result = {secteurs : secteurRep, annees : anneesRep, diplome :  diplomeRep}

                newFormation.userResult = JSON.stringify(result)

                setActFormation(newFormation)
                saveUserFormation(newFormation)
              }}
            >
              {languageValues?.continue[actLanguage]}
            </Button>
          </Box>
        </Box>
      </CenterContainer>

    </Box>
  )
}


export default IcebreakerQuestions
